import { CSSProperties, ReactNode } from "react";
import MUITheme from "components/MUITheme";
import MUITooltip from "@mui/material/Tooltip";
import { InfoIcon } from "../Icon";

import "./Tooltip.scss";

interface TooltipProps {
    tooltipBody: string | ReactNode;
    style?: CSSProperties;
    children?: ReactNode;
}

function Tooltip({ tooltipBody, style, children }: TooltipProps) {
    return (
        <MUITheme>
            <MUITooltip
                title={<span style={{ padding: "10px", display: "flex" }}>{tooltipBody}</span>}
                placement="top"
                style={{ padding: 0 }}
                leaveDelay={50}
                PopperProps={tooltipPopperConfig}
            >
                <span style={{ display: "grid", placeItems: "center" }}>
                    {children || (
                        <span className="tooltip" style={style}>
                            <InfoIcon />
                        </span>
                    )}
                </span>
            </MUITooltip>
        </MUITheme>
    );
}

const tooltipPopperConfig = {
    popperOptions: {
        modifiers: [
            {
                name: "flip",
                options: {
                    fallbackPlacements: ["bottom"],
                },
            },
        ],
    },
};

export default Tooltip;
